import { useEffect, useState } from "react";
import { Lightbulb, ArrowsClockwise } from "@phosphor-icons/react";
import { teleproApi } from "../../lib/teleproApi";

// VAGUE 44 — « Mes conseils commerciaux » (IA + conseils standards de secours).
export default function SalesAdviceCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = (force = false) => {
    setLoading(true);
    teleproApi.get(`/me/advice${force ? "?force=true" : ""}`)
      .then((r) => setData(r.data)).catch(() => setData({ error: true })).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <section className="bg-card border border-border rounded-sm p-4 sm:p-5" data-testid="sales-advice-card">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h3 className="font-display text-base font-medium flex items-center gap-2">
          <Lightbulb size={16} weight="duotone" className="text-[#E0B043]"/> Mes conseils commerciaux
        </h3>
        <div className="flex items-center gap-2">
          {data?.source && (
            <span className={`text-[10px] font-bold uppercase tracking-wider rounded-sm px-1.5 py-0.5 border ${data.source === "ai" ? "bg-primary/10 text-primary border-primary/30" : "bg-muted text-muted-foreground border-border"}`} data-testid="sales-advice-source">
              {data.source === "ai" ? "Personnalisé IA" : "Conseils standards"}
            </span>
          )}
          <button type="button" onClick={() => load(true)} disabled={loading} className="p-1 text-muted-foreground hover:text-primary disabled:opacity-50" aria-label="Actualiser" data-testid="sales-advice-refresh">
            <ArrowsClockwise size={14} className={loading ? "animate-spin" : ""}/>
          </button>
        </div>
      </div>
      {!data ? <div className="text-sm text-muted-foreground">Analyse de tes 30 derniers jours…</div>
        : data.error ? <div className="text-sm text-secondary">Conseils indisponibles pour le moment.</div> : (
        <>
          <ol className="space-y-2.5">
            {data.advice.map((a, i) => (
              <li key={i} className="flex gap-2.5" data-testid={`sales-advice-item-${i}`}>
                <span className="w-5 h-5 shrink-0 grid place-items-center rounded-full bg-[#E0B043]/20 text-[#8a6a14] text-[11px] font-bold">{i + 1}</span>
                <div>
                  <div className="text-sm font-semibold">{a.title}</div>
                  <p className="text-xs text-foreground/80 leading-relaxed">{a.text}</p>
                </div>
              </li>
            ))}
          </ol>
          <p className="mt-3 text-[10px] text-muted-foreground">
            Basé sur tes appels des 30 derniers jours : {data.metrics.calls} appels · contact {data.metrics.contact_rate ?? "—"} % · conversion sur joints {data.metrics.conversion_rate ?? "—"} %.
          </p>
        </>
      )}
    </section>
  );
}
